import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./Games.scss";
import { PAGE_SIZE } from "../../../constants";
import { Link } from "react-router-dom";
import SpinTheWheelRatesTable from "../../Tables/SpinTheWheelRates";
import {
	createSpinRate,
	deleteSpinRate,
	fetchSpinRates,
	resetDeleteStatusSpinRate,
	updateSpinRate,
} from "../../../actions/spinTheWheelRate";
import { ReactSVG } from "react-svg";
import SpinRateForm from "../../Forms/SpinTheWheelRate";

const SpinTheWheelRatesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { spinRates, loading } = useSelector((state) => state.fetchSpinRates);
	const { spinRateDeleted } = useSelector((state) => state.deleteSpinRate);
	const { status: updateStatus } = useSelector((state) => state.updateSpinRate);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({});
	const [spinRateId, setSpinRateId] = useState(null);
	const limit = Number(PAGE_SIZE) || 20;
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRateId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRateId(null);
	};

	const handleEdit = (record) => {
		showModal();
		setSpinRateId(record.id);
		form.setFieldsValue({
			...record,
		});
	};

	const handleClickDelete = (record) => {
		dispatch(deleteSpinRate(record.id));
	};

	const addNewRateClick = () => {
		showModal();
		form.resetFields();
	};

	const handleSubmitForm = (values) => {
		if (spinRateId) {
			dispatch(updateSpinRate(spinRateId, values));
		} else {
			dispatch(createSpinRate(values));
		}
		handleOk();
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSpinRates({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		if (spinRateDeleted) {
			dispatch(fetchSpinRates({ start: 0, count: PAGE_SIZE }));
			dispatch(resetDeleteStatusSpinRate());
		}
	}, [spinRateDeleted]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchSpinRates({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (spinRates) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: spinRates.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [spinRates]);

	useEffect(() => {
		dispatch(fetchSpinRates({ start: 0, count: PAGE_SIZE }));
	}, []);

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Dropdown.Button overlay={() => tableActionMenu(record)} />
			</span>
		);
	};

	const tableActionMenu = (record) => (
		<Menu className="table-action-menu">
			<Menu.Item key="view">
				<Link to={`/spin-the-wheel/rates/${record?.id}`}>
					<Button className="btn-table-action-primary" type="link">
						Show
					</Button>
				</Link>
			</Menu.Item>
			<Menu.Item key="edit">
				<Button
					className="btn-table-action-primary"
					type="link"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</Menu.Item>
			<Menu.Item key="delete">
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</Menu.Item>
		</Menu>
	);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-rates-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Rates</li>
						</ul>
					</div>
					<div>
						<Button
							type="primary"
							className="btn btn-primary"
							onClick={addNewRateClick}
						>
							New Rate
							<ReactSVG src="/icons/post-add.svg" />
						</Button>
					</div>
				</div>
				<div className="page-content">
					{spinRates && (
						<SpinTheWheelRatesTable
							rowKey="id"
							dataSource={spinRates.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={50}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="spin-form-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{spinRates && (
						<SpinRateForm
							form={form}
							spinRateId={spinRateId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default SpinTheWheelRatesPage;
